export default __webpack_public_path__ + "static/media/130_burghorror.9ec89eee.webp";